import {
  GeographicalStatisticsObject,
  topPayorsMOSECRProps,
} from "src/pages/manufacturer/types";
import packageInfo from "../../package.json";
import axios from "axios";
import { COLOR_LIST } from "src/constants/cases";
import { UserType } from "src/types/users";
import { matchPath } from "react-router-dom";

export const objectToQueryString = (obj: any) => {
  const keys = Object.keys(obj);
  const keyValuePairs = keys.map((key) => {
    return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
  });
  return keyValuePairs.join("&");
  // more code goes here
};

export const wrapperFunction = (value: GeographicalStatisticsObject[]) => {
  const dataArray: Array<[string, number]> = [];

  // Map of specific codes for U.S. territories
  const territoryMap: { [key: string]: string[] } = {
    "us-pr": ['pr-3614'],
    "us-gu": ['gu-3605'],
    "us-as": ['as-6515', 'as-6514'],
    "us-mp": ['mp-ti', 'mp-sa', 'mp-ro'],
    "us-vi": ['vi-3617', 'vi-6398', 'vi-6399']
  };

  if (value && value.length > 0) {
    value.forEach((item) => {
      const stateCode = item.state.toLocaleLowerCase();
      const prefixedCode = "us-" + stateCode;

      // Check if the state is in the territoryMap
      if (territoryMap[prefixedCode]) {
        // Add all associated codes for the territory
        territoryMap[prefixedCode].forEach(code => {
          dataArray.push([code, item.case_count]);
        });
      } else {
        // For regular states
        dataArray.push([prefixedCode, item.case_count]);
      }
    });
  }

  return dataArray;
};

export const wrapperFunctionPieChart = (
  pieChartData: topPayorsMOSECRProps[]
) => {
  return [
    {
      name: "Value",
      type: "pie",
      data:pieChartData && pieChartData.map((item,key) => (item.name !== null ? {
        name: `${(item.name || "")
          .toUpperCase().replace(/_/g, " ")}`,
          //.replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())}`,
        title:`${(item.name || "")
          .toUpperCase()
          .replace(/_/g, " ")
        }`,
        // value:item.value,
        y: item.value,
        color:COLOR_LIST[key]
      }:{
        name: `${('null')
          // .toLowerCase()
          // .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())
        }`,
        title:`${('null')
          // .toLowerCase()
          // .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())
        }`,
        // value:item.value,
        y: item.value,
        color:COLOR_LIST[key]
      })),
    },
  ];
};

export const updateApiVersion = async () => {
  const response = await axios(
    `${process.env.REACT_APP_BASE_URL}/update_api_version?APP_VERSION=${packageInfo.version}`,
    {
      method: "GET",
      headers: {
        ClientDb: process.env.REACT_APP_CLIENT_DB,
      },
    }
  );
//  console.log(response, "     ");
};

export const emptyCacheAndCookies = () => {
  document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  if ("caches" in window) {
    caches.keys().then((names) => {
      // Delete all the cache files
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    // Makes sure the page reloads. Changes are only visible after you refresh.
    setTimeout(() => window.location.reload(), 2000);
  }
};

export const formatPhoneNumber = (phoneNumber?: number | string | null) => {
  if (phoneNumber === undefined || phoneNumber === null) {
    return "N/A";
  }

  const cleaned = phoneNumber.toString().replace(/\D/g, '');

  if (cleaned.length !== 10) {
    return phoneNumber.toString();
  }
  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const formatSSN = (ssn: number | string) => {
  const cleaned = (ssn).toString().replace(/\D/g, '');
  if (cleaned.length !== 9) {
    return ssn.toString(); // Return as-is if not valid
  }
  return cleaned.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
};

export const formatFixedWithCommas = (value: number): string => {
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    
};

export const formatCurrency = (value: number): string => {
  return value != null
      ? `$${value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
      : '';
};

export const formatCurrencyWithoutSign = (value: number): string => {
  return`${value.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
    
};
export const isValidDate = (value: string | null): boolean => {
  return !!value && !isNaN(Date.parse(value));
}
const ACCESS_TO_ZILRETTA_DRUG = [
  'LAbbott@its.jnj.com','JBezold@its.jnj.com','LCamara@its.jnj.com',
  'FCistaro@its.jnj.com','WCook@ITS.JNJ.com','AGladfel@its.jnj.com',
  'JLiving4@its.jnj.com','LLutz@its.jnj.com','jLynch50@its.jnj.com',
  'JMcGlinc@its.jnj.com','TMeehan3@ITS.JNJ.com','JMontice@its.jnj.com',
  'bpember@its.jnj.com','RRamire5@its.jnj.com','JRANDOL2@its.jnj.com',
  'PStead2@ITS.JNJ.com','JUnderw1@ITS.JNJ.com','uwyman@its.jnj.com',
  'GYoung20@its.jnj.com','staging_jbezold@its.jnj.com','staging_fcistaro@its.jnj.com',
  'demojnj@pacira.com','new-testzilretta@aks.com'
]
const zilrettaAccessSet = new Set(
  ACCESS_TO_ZILRETTA_DRUG.map(email => email.toLowerCase())
);
// export const normalizeDrugSelection = (
//   drugName?: string,
//   reportName?: string,
//   userEmail?: string
// ): string => {
  
//   if(!drugName && isZilrettaUser (userEmail || ""))  return 'zilretta';
  

//   if (!drugName && reportName?.toLowerCase() === "am_report" && isZilrettaUser (userEmail || "")) {
//       return "zilretta"
//   }
//   if(!drugName) return '' ;

//   // agar AM report hai aur user list me hai → force ZILRETTA
//   if (
//     reportName?.toLowerCase() === "am_report" &&
//     userEmail &&
//     zilrettaAccessSet.has(userEmail.toLowerCase())
//   ) {
//     return "zilretta";
//   }

//   // normal behavior → All Product ko empty karna
//   return  drugName && drugName !== "All Product" ? drugName : "";
// };
export const normalizeDrugSelection = (
  userData: UserType | null,
  drugName?: string,
  reportName?: string,
): string => {
  const isAmReport = reportName?.toLowerCase() === "am_report";

  if (!drugName && userData?.is_jnj) {
    return "zilretta";
  } else if (!drugName && isAmReport && isZilrettaUser(userData)) {
    return "zilretta";
  } else if (!drugName) {
    return "";
  } else if (isAmReport && userData && userData.is_jnj) {
    return "zilretta";
  } else if (drugName !== "All Product") {
    return drugName;
  } else {
    return "";
  }
};

export const isZilrettaUser = (userData: UserType | null): boolean => {
  return userData && typeof userData.is_jnj === 'boolean' && typeof userData.is_zilretta_user === 'boolean' ? (userData.is_jnj || userData.is_zilretta_user) : false;
};

export const isIoveraUser = (userData: UserType | null): boolean => {
  return userData  && typeof userData.is_iovera_user === 'boolean' ? userData.is_iovera_user : false;
};

export const zilrettaDrugSelection = (
  userData: UserType | null,
  drugName?: string,
): string => {

  if (isZilrettaUser (userData)) {
      return "zilretta"
  }else{
    return  drugName && drugName !== "All Product" ? drugName :  "All Product";
  }
  
};
export function isMobileOrTablet() {
  const ua = navigator.userAgent.toLowerCase();

  // Check via userAgentData (Chromium-based browsers only)
  if (Object.hasOwn(navigator, "userAgentData")) {
    (navigator as any).userAgentData.getHighEntropyValues(["model"])
      .then((data: any) => {
        if (/mobile|iphone|ipod|android|ipad|tablet/i.test(data.model || '')) {
          return true;
        }
      })
      .catch(() => false);
  }

  // Traditional UA check (covers older iPads or browsers that expose 'iPad')
  if (/mobile|iphone|ipod|android|ipad|tablet/.test(ua)) {
    return true;
  }

  // Modern iPads (iPadOS 13+) spoof as Mac, so detect Mac + touch screen
  const isMacTouchDevice =
    /macintosh/.test(ua) && navigator.maxTouchPoints > 1;

  return isMacTouchDevice;
}

export const isRouteAllowed = (
  pathname: string,
  allowedRoutes: string[]
): boolean => {
  return allowedRoutes.some(route =>
    matchPath(
      { path: route, end: true },
      pathname
    )
  );
};
